import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { InviteSignUpPage } from '@/app/Auth/pages/InviteSignUpPage';
import { PublicPage } from '@/app/PublicPage';
import type { PageStaticData } from '@/shared/routing';
import { browserLanguageLoaded } from '@/shared/utils/internationalisation';

export const Route = createFileRoute('/auth/signup/invite')({
    staticData: { access: 'public', chrome: 'none' } satisfies PageStaticData,
    validateSearch: stringSearch({ payload: 'optional' }),
    loader: () => browserLanguageLoaded(),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const payload = Route.useSearch({ select: (search) => search.payload });
    return (
        <PublicPage>
            <InviteSignUpPage payload={payload} />
        </PublicPage>
    );
}
